import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_CALENDAR_EVENT_BEGIN](state) {
    state.calendarEventsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_CALENDAR_EVENT_SUCCESS](state, calendarEvents) {
    state.calendarEventsGetError = null;
    state.calendarEvents = calendarEvents;
    state.calendarEventsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_CALENDAR_EVENT_ERROR](state, err) {
    state.calendarEventsGetState = API_STATES.REQUEST_ERROR;
    state.calendarEventsGetError = err;
  },
  [types.CREATE_CALENDAR_EVENT_BEGIN](state) {
    state.calendarEventCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_CALENDAR_EVENT_SUCCESS](state, data) {
    state.calendarEventCreateError = null
    state.calendarEventCreateState = API_STATES.REQUEST_SUCCESS
    state.calendarEvent=data
  },
  [types.CREATE_CALENDAR_EVENT_ERROR](state, err) {
    state.calendarEventCreateState = API_STATES.REQUEST_ERROR
    state.calendarEventCreateError = err
  },

  [types.UPDATE_CALENDAR_EVENT_BEGIN](state) {
    state.calendarEventUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_CALENDAR_EVENT_SUCCESS](state, data) {
    state.calendarEventUpdateError = null
    state.calendarEvent=data
    state.calendarEventUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_CALENDAR_EVENT_ERROR](state, err) {
    state.calendarEventUpdateState = API_STATES.REQUEST_ERROR
    state.calendarEventUpdateError = err
  },
  [types.DELETE_CALENDAR_EVENT_BEGIN](state) {
    state.calendarEventDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_CALENDAR_EVENT_SUCCESS](state) {
    state.calendarEventDeleteError = null;
    state.calendarEventDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_CALENDAR_EVENT_ERROR](state, err) {
    state.calendarEventDeleteState = API_STATES.REQUEST_ERROR;
    state.calendarEventDeleteError = err;
  },
};

export default mutations;